import gql from 'graphql-tag';

const vraReasonsQuery = gql`
  query vraReasonsQuery {
    vraReasons {
      active
      groupId
      id
      orderId
      returnReason
    }
  }
`;

export default vraReasonsQuery;
